<template>
  <div v-if="isSlotVisible()">
    <slot></slot>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'wt-auth',
  props: ['hasAnyRole', 'hasAnyPremission'],
  methods: {
    isSlotVisible() {
      // if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'production') {
      //   return true
      // }
      if (this.hasAnyPremission !== '' && this.hasAnyPremission !== null && this.hasAnyPremission !== undefined) {
        if (this.permissionCodes.indexOf(this.hasAnyPremission) < 0) {
          return false
        }
      }
      return true
    }
  },
  computed: {
    ...mapGetters([
      'permissionCodes'
    ])
  }
}
</script>

<style scoped>

</style>
